import React, { useState, useEffect } from "react"
import Footer from "src/components/footer"
import { HelpHeader, HelpInfo } from "src/components/help-center-section"
import { Text, HeaderMain } from "src/components/help-center-section/styled-compnent"
import styled from "styled-components"
import ApolloClient from "apollo-client"
import { useLocation, useParams } from "react-router"
import { NormalizedCacheObject } from "apollo-cache-inmemory"
import { fetchHelpCenter } from "./services"
import Loader from "src/dashboards/components/loader"
import GoogleAdSense from "src/components/google-ad-sense"
import moment from "moment"
import ReactHelmet from "src/components/react-helmet"
import "./style.scss"

type Props = {
  client: ApolloClient<NormalizedCacheObject>
}

type Info = {
  title: string
  description: string
}

type Data = {
  updatedAt: string
  description: string
}

export const CollectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 2rem 4rem;
  width: 70%;
  margin: 2rem auto;
  border-radius: 4px;
  background: #fff;
  @media (max-width: 900px) {
    flex-direction: column;
    width: 80%;
    padding: 1rem;
  }
  @media (max-width: 1600px) {
    width: 90%;
  }

  @media (max-width: 1400px) {
    width: 100%;
  }
`

export const ContentContainer = styled.div`
  flex: 1;
  margin-right: 2rem;

  @media (max-width: 900px) {
    margin-right: 0;
    width: 100%;
  }
`

export const AdContainer = styled.div`
  width: 300px;

  @media (max-width: 900px) {
    display: none;
  }
`

export const ArticleDes = styled.div`
  margin: 2rem 0;
`

export const DescText = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: justify;
`

const HelpSingleArticle = (props: Props) => {
  const { client } = props
  const { id } = useParams<{ id: string }>()
  const location = useLocation<{ state: Info }>()

  const [isLoading, setLoading] = useState(false)
  const [info, setInfo] = useState<Info>({ title: "", description: "" })
  const [data, setData] = useState<Data>({ updatedAt: "", description: "" })

  const init = async () => {
    setLoading(true)
    const resp: any = await fetchHelpCenter(client, id)
    if (resp && resp.data) {
      const { helpCenter } = resp.data
      setData(helpCenter || { updatedAt: "", description: "" })
    } else {
      setData({ updatedAt: "", description: "" })
    }
    setLoading(false)
  }

  useEffect(() => {
    init()
    if (location && location.state) {
      setInfo(location.state)
    }
  }, [])

  return (
    <>
      <HeaderMain>
        <HelpHeader client={client} />
      </HeaderMain>

      <ReactHelmet url="" title={info.title} description={info.title} id="" city="" />
      <CollectionContainer id="single-help-article">
        <ContentContainer>
          <Text fontSize={25}>{info.title}</Text>

          <Text fontSize={17} color={"#8F919D"} margin="12px 0">
            {info.description}
          </Text>
          <HelpInfo
            title="Written by Tolobi Team"
            subTitle={`Updated over ${moment.utc(Number(data.updatedAt)).fromNow()}`}
          />
          <ArticleDes>
            <Text fontSize={20} color={"#8F919D"}>
              <DescText
                className="editor-data"
                dangerouslySetInnerHTML={{ __html: data.description }}
              ></DescText>
            </Text>
          </ArticleDes>
        </ContentContainer>
        <AdContainer>
           <GoogleAdSense
                styles={{
                  width: 400,
                  height: 300,
                  float: "left",
                  borderRadius: 6,
                }}
              />
        </AdContainer>
      </CollectionContainer>
      <GoogleAdSense
        styles={{
          width: "100%",
          height: 250,
          float: "left",
        }}
      />
      <Footer />
      <Loader loader={isLoading} />
    </>
  )
}

export default HelpSingleArticle
